import React, { useState, useEffect, useRef } from "react";
import "./AdsComponent.css";
import getHandbook from "./../../assets/AdsBanners/hand-book-sale.png";
import trainerBanner from "./../../assets/AdsBanners/trainer-banner.jpeg";

const handbookOrderMessage = [
  "Hi, මට Driving Handbook + Model Paper Pack එක order කරන්න අවශ්‍යයි.",
  "வணக்கம், ஓட்டுநர் கையேடு + மாதிரி வினாத்தாள் தொகுப்பை ஆர்டர் செய்ய விரும்புகிறேன்.",
  "Hi, I would like to order the Driving Handbook + Model Paper Pack.",
  "",
  "Name:",
  "Address:",
  "Phone number 1:",
  "Phone number 2:",
].join("\n");

const slides = [
  {
    image: trainerBanner,
    link: "/driving-license-video-guide",
    alt: "Hire a personal driving instructor online in Sri Lanka",
  },
  {
    image: getHandbook,
    link: `https://wa.me/94712367846?text=${encodeURIComponent(
      handbookOrderMessage
    )}`,
    alt: "Get driving licence exam papers and handbook in Sri Lanka",
  },
];

function AdsSlider({
  autoRotate = true,
  rotationInterval = 5000,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(1);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // RESPONSIVE: number of visible images
  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;

      let count = 1;

      if (width < 768) count = 1;
      else if (width < 1024) count = 2;
      else count = 3;

      // prevent requesting more slides than available
      if (count > slides.length) count = slides.length;

      setVisibleSlides(count);
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  // True max index — image-by-image sliding
  const maxIndex = slides.length - visibleSlides;

  // AUTO ROTATE (image by image)
  useEffect(() => {
    if (!autoRotate) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, rotationInterval);
    return () => clearInterval(timer);
  }, [autoRotate, rotationInterval, maxIndex]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  // TOUCH SWIPE
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    const minDistance = 50;

    if (diff > minDistance) handleNext();
    if (diff < -minDistance) handlePrev();

    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  // Page-based indicators
  const totalPages = Math.ceil(slides.length - (visibleSlides - 1));

  return (
    <div className="ads-slider-container">
      <div className="carousel-wrapper">
        <div
          className="carousel-inner"
          style={{
            width: `${slides.length * (100 / visibleSlides)}%`,
            transform: `translateX(-${currentIndex * (100 / slides.length)}%)`,
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {slides.map((slide, i) => (
            <div
              key={i}
              className="slide-item"
              style={{
                flex: `0 0 ${100 / slides.length}%`,
              }}
            >
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <div className="image-wrapper">
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    className="tile-image"
                  />
                </div>
              </a>
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button className="carousel-nav carousel-prev z-0" onClick={handlePrev}>
          <span className="nav-arrow">&#8249;</span>
        </button>
        <button className="carousel-nav carousel-next z-0" onClick={handleNext}>
          <span className="nav-arrow">&#8250;</span>
        </button>

        {/* Indicators */}
        {window.innerWidth < 768 ? null : (
          <div className="carousel-indicators">
            {[...Array(totalPages)].map((_, idx) => (
              <button
                key={idx}
                className={`indicator ${
                  idx === Math.floor(currentIndex) ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(idx)}
              ></button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdsSlider;
